import AppDefaults from "../../utils/app.config";
import { get, getDetais, getNetworks, save, update, getCurrencyData } from "./api"
export const getLooups = async (url, customerId) => {
    try {
        let response = await getDetais(url, customerId);
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        else {
            return { success: false, error: response };
        }
    }
    catch (error) {
        return error
    }
}
export const getCoins = async (url, customerId) => {
    try {
        let response = await get(url, customerId);
        if (response.status === 200) {
            return response.data
        }
        else {
            return response;
        }
    }
    catch (error) {
        return error
    }
}
export const getTypes = async (url) => {
    try {
        let response = await get(url);
        if (response.status === 200) {
            return response.data
        }
        else {
            return response
        }
    }
    catch (error) {
        return error
    }
}
export const getNetworkLu = async (url, coinName, userId) => {
    try {
        let response = await getNetworks(url, coinName, userId);
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        else{
            return { success: false, error: response };
        }
    }
    catch (error) {
        return error
    }
}

export const getCurrency = async (url, coinName, network, merchant,id) => {
    try {
        let response = await getCurrencyData(url, coinName, network, merchant,id);
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        else{
            return { success: false, error: response };
        }
    }
    catch (error) {
        return error
    }
}

export const savePayment = async (url, values, customerId, id, merchnatName) => {
    try {
        let obj = {
            ...values,
            id: id === 'create' ? AppDefaults.GUID_ID : id,
            customerId: customerId,
            merchantName: merchnatName
        }
        let _url = id === 'create' ? url : 'Merchant/updatepaymentlinks'
        let _methods = id === 'create' ? save : update;
        let response = await _methods(_url, obj);
        if (response.status === 200) {
            return response.data
        }
        else {
            return response.ok;
        }
    }
    catch (error) {
        return error
    }

}
export const geCustomertPaymentDetails = async (url, userId) => {
    try {
        let response = await getDetais(url, userId);
        if (response.status === 200) {
            return response.data
        }
        else{
            return response
        }
    }
    catch (error) {
        return error
    }

}